export const colorStyles = (isDark) => ({
  control: (styles, { isFocused }) => ({
    ...styles,
    minHeight: "42px",
    borderRadius: "8px",
    borderWidth: "2px",
    backgroundColor: isDark ? "#2E2E40" : "white",
    borderColor: isFocused ? "var(--primary-color)" : "var(--secondary-color)",
    boxShadow: "none",
    transition: "border-color 0.3s ease",
    "&:hover": {
      borderColor: isFocused ? "var(--primary-color)" : "var(--secondary-color)",
    },
  }),
  menu: (styles) => ({
    ...styles,
    zIndex: 999,
  }),
  option: (styles, state) => ({
    ...styles,
    color: state.data.isDisabled ? 'black' : '#241F5C',
    backgroundColor: state.data.isDisabled ? '#f0f0f0' : 'FFFFFF',
    cursor: state.data.isDisabled ? 'not-allowed' : 'pointer',
    ":active": {
      ...styles[":active"],
      backgroundColor: "#0000000a",
    },
    ":hover": {
      ...styles[":active"],
      backgroundColor: "#0000000a",
    },
  }),
  input: (styles) => ({
    ...styles,
  }),
  placeholder: (styles) => ({
    ...styles,
    color: isDark ? "#6E6E6E" : "#241F5Caa",
  }),
  singleValue: (styles) => ({
    ...styles,
    color: "#000",
  }),
  valueContainer: (styles) => ({
    ...styles,
    color: "#241F5C",
    padding: "0px 16px",
  }),
});
